import { render, staticRenderFns } from "./robotView1.vue?vue&type=template&id=696a7682&scoped=true"
import script from "./robotView1.vue?vue&type=script&lang=js"
export * from "./robotView1.vue?vue&type=script&lang=js"
import style0 from "./robotView1.vue?vue&type=style&index=0&id=696a7682&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696a7682",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('696a7682')) {
      api.createRecord('696a7682', component.options)
    } else {
      api.reload('696a7682', component.options)
    }
    module.hot.accept("./robotView1.vue?vue&type=template&id=696a7682&scoped=true", function () {
      api.rerender('696a7682', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/robotView1.vue"
export default component.exports